import { getDrupalMenu } from '@lucid/gatsby-theme-lucid';
import { graphql, useStaticQuery } from 'gatsby';

export const useMenuDefaultFooter = (langPrefix: string) =>
  getDrupalMenu(
    useStaticQuery(
      graphql`
        {
          drupal {
            menuLinkContentQuery(
              limit: 10000
              sort: [
                { field: "parent", direction: ASC }
                { field: "weight", direction: ASC }
              ]
              filter: {
                conditions: [
                  { field: "bundle", value: "default-footer", operator: EQUAL }
                ]
              }
            ) {
              entities {
                ...useMenuHook
              }
            }
          }
        }
      `
    ),
    langPrefix
  );

export const query = graphql`
  fragment useMenuDefaultFooter on Drupal_MenuLinkContentDefaultFooter {
    fieldKey
    fieldBeaconElementDetail
    fieldKmEventName
    fieldDisableLanguage
    fieldProductLink
    fieldMarketo {
      entity {
        entityTranslations {
          ...marketo
        }
      }
    }
  }
`;
